/**
 * Home-screen install: capture the browser's install prompt so Settings can
 * offer a button; iOS has no prompt and gets instructions instead.
 */

let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn(false));
  });
}

export function canPromptInstall() {
  return !!deferredPrompt;
}

export function onInstallAvailable(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export async function promptInstall() {
  if (!deferredPrompt) return null;
  const p = deferredPrompt;
  deferredPrompt = null;
  p.prompt();
  try {
    const choice = await p.userChoice;
    return choice?.outcome || null;
  } catch {
    return null;
  }
}
